<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.hotel') }}</div>
                <el-select
                  v-model="searchParams.hotelIdList"
                  multiple
                  collapse-tags
                  filterable
                  clearable
                  placeholder=""
                >
                  <el-option
                    v-for="item in hotelOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.fromDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateFrom"
                  mode="date"
                  @input="onChangeDateFrom"
                />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.toDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateTo"
                  mode="date"
                  @input="onChangeDateTo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">
                {{ $t('views.report.walkInGuestReport') }}
              </span>
            </div>
            <div class="flex" style="gap: 10px">
              <InfoBtn @click="noteDialogVisible = true" />

              <el-dropdown trigger="click" @command="onClickDropdownItem">
                <das-button
                  color="primary"
                  size="medium"
                  :rounded="false"
                  outline
                  icon
                >
                  <i class="el-icon-download"></i>
                </das-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">
                    {{ $t('button.exportPdf') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="excel">
                    {{ $t('button.exportExcel') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <hr />

          <div v-loading="gridLoading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              dom-layout="scroll"
              :auto-size-cell="true"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('dialog.titleNote')"
      :visible.sync="noteDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="note-container">
            <ul>
              <li>Recode: Hiển thị mã đặt phòng</li>
              <li>Hạng phòng: Hiển thị hạng phòng của đặt phòng</li>
              <li>
                Doanh thu: Hiển thị Doanh thu tổng bao gồm + Dịch vụ trong phòng
                + ăn uống (Nếu được đẩy về phòng) không tính vé
              </li>
              <li>
                Ngày Checkin: Hiển thị ngày Check in của đặt phòng. Format
                DD/MM/YY
              </li>
              <li>
                Ngày Checkout: Hiển thị ngày Check- out của đặt phòng. Format
                DD/MM/YYYY
              </li>
              <li>Lễ tân: Hiển thị tài khoản lễ tân thực hiện đặt phòng</li>
              <li>
                Lấy dữ liệu khi các đặt phòng có check tại checkbox Walkin
              </li>
            </ul>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="noteDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DasButton from '@/components/ui/DasButton.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import Multiselect from 'vue-multiselect'
import InfoBtn from './components/InfoBtn.vue'
import { getAllHotel } from '@/api/hotel.js'
import {
  getWalkinGuestReportApi,
  getWalkinGuestReportApiExcel
} from '@/api/report_service/report'
import { downFile } from '@/utils/file-handler'

export default {
  components: {
    DasButton,
    CalendarSelect,
    // eslint-disable-next-line vue/no-unused-components
    Multiselect,
    InfoBtn
  },
  data() {
    return {
      noteDialogVisible: false,
      searchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        hotelIdList: null
      },
      hotelOptions: [],
      gridLoading: false,
      columns: [
        {
          headerName: this.$t('grid.column.recode'),
          field: 'recode',
          tooltipField: 'recode',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 130,
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'roomLevel',
          tooltipField: 'roomLevel',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 150,
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.revenue'),
          field: 'revenue',
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 150,
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          flex: 1
        },
        {
          headerName: this.$t('grid.column.checkinDate'),
          field: 'cidate',

          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 180,
          maxWidth: 180
        },
        {
          headerName: this.$t('grid.column.checkoutDate'),
          field: 'codate',

          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 180,
          maxWidth: 180
        },
        {
          headerName: this.$t('grid.column.receptionist'),
          field: 'receptionist',
          tooltipField: 'receptionist',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 200
        }
      ],
      rows: [{}]
    }
  },
  mounted() {
    this.getHotelOptions()
    this.attachData()
  },
  methods: {
    checkValidDateRange(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom > dateTo) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.fromDateMustEarlierThanToDate')
        })
        return false
      }
      return true
    },

    onChangeDateFrom(date) {
      this.searchParams.dateFrom = date
      if (!this.checkValidDateRange(date, this.searchParams.dateTo)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    onChangeDateTo(date) {
      this.searchParams.dateTo = date
      if (!this.checkValidDateRange(this.searchParams.dateFrom, date)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    // SELECT OPTIONS
    getHotelOptions() {
      getAllHotel().then(res => {
        this.hotelOptions = res.data
      })
    },

    onSearch() {
      this.attachData()
    },
    onReset() {
      this.searchParams = {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        hotelIdList: null
      }
      this.attachData()
    },
    onClickDropdownItem(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },
    attachData() {
      this.gridLoading = true
      getWalkinGuestReportApi(this.searchParams)
        .then(res => {
          this.rows = res.data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading = false
        })
    },
    downloadExcel() {
      this.gridLoading = true
      getWalkinGuestReportApiExcel(this.searchParams)
        .then(res => {
          const date = this.$moment().format('DD-MM-YYYY')
          downFile(res, 'bao_cao_khach_walkin_' + date + '.xlsx')
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading = false
        })
    }
  }
}
</script>

<style></style>
